/* eslint-disable fp/no-let */
/* eslint-disable @scandipwa/scandipwa-guidelines/use-namespace */
/* eslint-disable max-lines */
/* eslint-disable no-undef */
/* eslint-disable max-len */
/* eslint-disable no-magic-numbers */
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
/* eslint-disable @scandipwa/scandipwa-guidelines/jsx-no-props-destruction */
/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/base-theme
 */
import {
    filter, get, includes, isEmpty
} from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { DEFAULT_STATE_NAME } from 'Component/NavigationAbstract/NavigationAbstract.config';
import MyAccountQuery from 'Query/MyAccount.query';
import {
    HomePageContainer as SourceHomePageContainer,
    mapDispatchToProps as sourceMapDispatchToProps,
    mapStateToProps as sourceMapStateToProps
} from 'SourceRoute/HomePage/HomePage.container';
import {
    PostsDispatcher,
    RecentsPostDispatcher
} from 'Store/GearzettePage';
import { updateGoogleRecaptcha } from 'Store/GoogleRecaptcha/GoogleRecaptcha.action';
import { HomePageDispatcher } from 'Store/HomePage';
import MaintenanceDispatcher from 'Store/Maintenance/Maintenance.dispatcher';
import { updateMeta } from 'Store/Meta/Meta.action';
import { changeNavigationState } from 'Store/Navigation/Navigation.action';
import { TOP_NAVIGATION_TYPE } from 'Store/Navigation/Navigation.reducer';
import { NewsletterSubscriptionDispatcher } from 'Store/NewsletterSubscription';
import { showNotification } from 'Store/Notification/Notification.action';
import { isSignedIn } from 'Util/Auth';
import { processAffiliateCode } from 'Util/FrontRunner/Affiliates/AffiliateCode';
import { updatePageInCookies } from 'Util/Helper';
import history from 'Util/History';
import { fetchMutation } from 'Util/Request';
import { convertQueryStringToKeyValuePairs } from 'Util/Url';

import HomePageComponent from './HomePage.component';

// export const cookies = new Cookies();

export const options = {
    sliderCategoryId: window.storeConfig.sliderCategoryId,
    productSliderCategoryId: window.storeConfig.productSliderCategoryId
};

// export const options = {
//    sliderCategoryId: '2',
//    productSliderCategoryId: '4'
// };

/** @namespace Pwa/Route/HomePage/Container/HomePageContainer */
export class HomePageContainer extends SourceHomePageContainer {
    componentWillMount() {
        // Process if any affiliate codes detected in the URL
        processAffiliateCode();
    }

    componentDidMount() {
        const {
            requestPage, toggleBreadcrumbs, changeHeaderState, checkMaintenance
        } = this.props;

        updatePageInCookies('HomePage');
        this.storeIdLookupAndRequest();
        this.metaLookupAndUpdate();
        // requestPage(options);
        // No breadcrumbs on homepage
        if (isSignedIn()) {
            localStorage.setItem('amazonPaySessionId', '');
            localStorage.setItem('isProgressCheckout', '');
            localStorage.setItem('changepayment', '');
        }
        changeHeaderState({
            name: DEFAULT_STATE_NAME,
            isHiddenOnMobile: false
        });

        const urlParams = convertQueryStringToKeyValuePairs(this.props.location.search) || {};
        const { affiliate_code = '', code = '' } = urlParams || {};

        // Customer invitation
        if (!isEmpty(code) && window.location.href.includes('customer/acceptinvitation')) {
            const {
                'customer%5Bjob_title%5D': job_title,
                'customer%5Btelephone%5D': telephone,
                'customer%5Bstatus%5D': status,
                'customer%5Bcustomer_id%5D': customer_id,
                'customer%5Bcompany_id%5D': company_id
            } = urlParams;
            const role_id = '';

            this.submitAcceptInvitation({
                code,
                role_id,
                job_title,
                telephone,
                status,
                customer_id,
                company_id
            });
            history.push('/');
        }
        checkMaintenance();
        this.requestPage();
    }

    componentDidUpdate() {
        if (window.$zopim) {
            $zopim.livechat.button.setOffsetVerticalMobile(0);
        }
    }

    metaLookupAndUpdate= () => {
        const period = 1000; // ms
        const sleep = setInterval(() => {
            const content = get(this.props, 'content', {});

            if (content) {
                const {
                    meta_keywords,
                    meta_description,
                    meta_title,
                    hreflang,
                    oggraph
                } = content;

                // eslint-disable-next-line eqeqeq
                if (!isEmpty(hreflang)) {
                    clearInterval(sleep);
                    const { updateMeta } = this.props;
                    updateMeta({
                        title: meta_title,
                        description: meta_description,
                        keywords: meta_keywords,
                        canonical_url: window.location.href,
                        hreflang,
                        oggraph
                    });
                }
            }
        }, period);
    };

    storeIdLookupAndRequest= () => {
        const period = 600; // ms
        const sleepyAlert = setInterval(() => {
            const { storeId } = window.storeConfig;
            if (storeId !== undefined) {
                clearInterval(sleepyAlert);
                const { requestPage } = this.props;
                const opt = {
                    sliderCategoryId: window.storeConfig.sliderCategoryId,
                    productSliderCategoryId: window.storeConfig.productSliderCategoryId
                };

                requestPage(opt);
            }
        }, period);
    };

    requestPage() {
        const { requestRecentsPost, store_id } = this.props;
        if (store_id !== 'undefined') {
            requestRecentsPost({ endpointUrl: '/gearzette?', store_id });
        }
    }

    submitAcceptInvitation= (options) => {
        fetchMutation(MyAccountQuery.getAcceptCompanyInviteMutation(
            options
        )).then(
            /** @namespace Pwa/Route/HomePage/Container/fetchMutation/then */
            ({ data }) => {
                const { showSuccessNotification } = this.props;
                showSuccessNotification(__('You have accepted the invitation to the company.'));
            },
            /** @namespace Pwa/Route/HomePage/Container/fetchMutation/then */
            (error) => {
                const { showErrorNotification, showSuccessNotification } = this.props;
                showErrorNotification(error[0].message);
            }
        );
        // TODO:: handle query call to accept invitation if customer in loggedin/ else, performa loggedin then have to do same
    };

    render() {
        return (
            <div block="HomePage">
                <HomePageComponent
                  { ...this.props }
                  isBreadcrumbsActive={ false }
                />
            </div>
        );
    }
}

/** @namespace Pwa/Route/HomePage/Container/processMobileAccordian */
export const processMobileAccordian = (data) => filter(data, (d) => includes(['shop', 'vehicle_finder', 'adventure', 'popular_vehicles', 'whats_new'], d.type));

/** @namespace Pwa/Route/HomePage/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    ...sourceMapStateToProps,
    slider: state.HomePageReducer.slider,
    productSlider: state.HomePageReducer.productSlider,
    content: state.HomePageReducer.content,
    newLetterPopupConfig: state.HomePageReducer.newLetterPopupConfig,
    mobileAccordian: processMobileAccordian(state.HeaderAndFooterReducer.mobileMenu),
    mobileHeaderTextBanner: state.HeaderAndFooterReducer.mobileHeaderTextBanner,
    isLoading: state.HomePageReducer.isLoading,
    companyCustomerData: state.HomePageReducer.companyCustomerData,
    bestSellerProductsData: state.HomePageReducer.bestSellerProductsData,
    isNewsletterLoading: state.NewsletterSubscriptionReducer.isLoading,
    showErrorNotification: PropTypes.func.isRequired,
    customer: state.MyAccountReducer.customer,
    companyProfile: state.CompanyReducer.company,
    recentsPost: state.GearzettePageReducer.recentsPost,
    store_id: window.storeConfig.storeId,
    googleRecaptchaToken: state.GoogleRecaptchaReducer.recaptchaToken,
    menu: state.HeaderAndFooterReducer.desktopMenu,
    vehicleSpecificSkus: state.VehicleFinderReducer.vehicleSpecificSkus,
    selectedVehicle: state.VehicleFinderReducer.selectedVehicle,
    vehicleList: state.CustomerGarageReducer.data

});

/** @namespace Pwa/Route/HomePage/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    ...sourceMapDispatchToProps,
    requestPage: (options) => HomePageDispatcher.handleData(dispatch, options),
    newsletterSubscribe: (options) => NewsletterSubscriptionDispatcher.subscribe(dispatch, options),
    changeHeaderState: (state) => dispatch(changeNavigationState(TOP_NAVIGATION_TYPE, state)),
    showErrorNotification: (error) => dispatch(showNotification('error', error)),
    showSuccessNotification: (message) => dispatch(showNotification('success', message)),
    updateMeta: (meta) => dispatch(updateMeta(meta)),
    checkMaintenance: () => MaintenanceDispatcher.handleData(dispatch),
    updateGoogleRecaptcha: (recaptchaToken) => dispatch(updateGoogleRecaptcha(recaptchaToken)),
    showNotification: (type, message) => dispatch(showNotification(type, message)),
    requestRecentsPost: (options) => RecentsPostDispatcher.handleFsyncData(dispatch, options),
    requestPosts: (options) => PostsDispatcher.handleFsyncData(dispatch, options),
    saveFormData: (options) => dispatch(updateVehicleFinderPageFormData(options))
});

export default connect(mapStateToProps, mapDispatchToProps)(HomePageContainer);
